export default __webpack_public_path__ + "static/ex6-signature-0043ce4675700c2ea266251977f1d96c.webp";